var map = {
	"./module-1/chapter/en/chapter-1-thumb.jpg": "be71",
	"./module-1/chapter/en/chapter-2-thumb.jpg": "1535",
	"./module-1/chapter/en/chapter-3-thumb.jpg": "4cb3",
	"./module-1/chapter/th/chapter-1-thumb.jpg": "69d2",
	"./module-1/chapter/th/chapter-2-thumb.jpg": "f82c",
	"./module-1/chapter/th/chapter-3-thumb.jpg": "ab28",
	"./module-1/en/module-thumb.jpg": "36f4",
	"./module-1/th/module-thumb.jpg": "ccd0",
	"./module-2/chapter/en/chapter-1-thumb.jpg": "daec",
	"./module-2/chapter/en/chapter-2-thumb.jpg": "d784",
	"./module-2/chapter/th/chapter-1-thumb.jpg": "689c",
	"./module-2/chapter/th/chapter-2-thumb.jpg": "01c9",
	"./module-2/en/module-thumb.jpg": "f9aa",
	"./module-2/th/module-thumb.jpg": "c015",
	"./module-3/chapter/en/chapter-1-thumb.jpg": "39e3",
	"./module-3/chapter/en/chapter-2-thumb.jpg": "f2c3",
	"./module-3/chapter/en/chapter-3-thumb.jpg": "4253",
	"./module-3/chapter/th/chapter-1-thumb.jpg": "d7a1",
	"./module-3/chapter/th/chapter-2-thumb.jpg": "3e42",
	"./module-3/chapter/th/chapter-3-thumb.jpg": "aa3f",
	"./module-3/en/module-thumb.jpg": "2ea6",
	"./module-3/th/module-thumb.jpg": "43a3",
	"./module-4/chapter/en/chapter-1-thumb.jpg": "7c89",
	"./module-4/chapter/th/chapter-1-thumb.jpg": "625f",
	"./module-4/en/module-thumb.jpg": "bc9a",
	"./module-4/th/module-thumb.jpg": "a84f",
	"./module-5/chapter/en/chapter-1-thumb.jpg": "1ee1",
	"./module-5/chapter/th/chapter-1-thumb.jpg": "a3b9",
	"./module-5/en/module-thumb.jpg": "0470",
	"./module-5/th/module-thumb.jpg": "3fe7",
	"./module-6/chapter/en/chapter-1-thumb.jpg": "ed72",
	"./module-6/chapter/en/chapter-2-thumb.jpg": "0027",
	"./module-6/chapter/th/chapter-1-thumb.jpg": "7f5f",
	"./module-6/chapter/th/chapter-2-thumb.jpg": "b762",
	"./module-6/en/module-thumb.jpg": "092c",
	"./module-6/th/module-thumb.jpg": "12c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f44";